/**
 * 票種代碼 → 中文名。定價編輯與訂單明細共用。
 *
 * 抽出來的原因：訂單明細少了票種欄時，一張混票種的套票訂單看起來就是「同商品同班次
 * 出現兩次、金額還不一樣」的重複列。而那個對照表原本只存在於定價頁裡。
 */
export const TICKET_TYPE_LABEL: Record<string, string> = {
  adult: '成人',
  senior: '敬老',
  child: '兒童',
  child_3_5: '兒童 3-5 歲',
  child_6_11: '兒童 6-11 歲',
  infant: '幼兒',
  early_bird: '早鳥',
  package_family: '家庭套裝',
  custom: '自訂',
};

/** 未知代碼原樣顯示——寧可讓人看到 `foo` 也不要顯示一個猜出來的名字。 */
export function ticketTypeLabel(code: string): string {
  return TICKET_TYPE_LABEL[code] ?? code;
}

/**
 * 顯示順序，與後端 `PricingResolver.TICKET_TYPE_DISPLAY_ORDER` 一致。
 *
 * **6–11 歲排在 3–5 歲之前**，與代碼的字典順序相反——照字母排會把年齡段倒過來呈現。
 */
export const TICKET_TYPE_DISPLAY_ORDER = [
  'adult',
  'senior',
  'child',
  'child_6_11',
  'child_3_5',
  'infant',
  'early_bird',
  'package_family',
  'custom',
] as const;

/**
 * 商品價目表（`ticket_prices` / `guest_ticket_prices`）可用的鍵。
 *
 * 成人不在內：它的原價是 `base_price`（住客是 `guest_base_price`），後端對含 `adult`
 * 的價目表會直接回 400。
 */
export const NON_ADULT_TICKET_TYPES = TICKET_TYPE_DISPLAY_ORDER.filter(
  (t) => t !== 'adult',
) as readonly string[];
